'use strict';

// this plugin allows you to use an attr selector `dash-case / snake-case` to call
// to call the data() method which only accepts camelCase. The benefit of data() is
// that it automatically JSON parses the value for you

module.exports = function($) {

  $.fn.swDataAttr = function(attrString, attrVal) {
    var $el = $(this);
    var splitAttr = attrString.split('-');

    if(splitAttr[0] !== 'data') {
      throw new Error('attribute string must start with \'data\'');
    }

    // drop the word data
    splitAttr.shift();

    // capitalize every word after the first
    for(var i = 1; i < splitAttr.length; i++) {
      splitAttr[i] = splitAttr[i].charAt(0).toUpperCase() + splitAttr[i].slice(1);
    }
    
    return $el.data(splitAttr.join(''), attrVal);
  };

};
